import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import ApproverGroup from './approver_group';
import ManagedInput from 'components/form/managed_input';
import RemoveControl from './remove_control';

import { connect } from 'react-redux';
import { addAssigneeGroup as addApproverGroup, changeStepMode, removeStep } from './store/workflow/actions';
import { modes } from './helper';

export const Step = ({ addApproverGroup, changeStepMode, removeStep, step }) => {
  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <div className="d-flex flex-row align-items-baseline">
          <h4 className="m-0"><b>Step {step.index + 1}</b></h4>
          { step.assigneeGroups.length > 1 &&
            <ManagedInput
              className="pt-1"
              options={modes}
              type="radioGroup"
              value={step.mode}
              onValueChange={value => changeStepMode(step, value)}
            />
          }
        </div>
        <RemoveControl ariaLabel="remove-step" onClick={() => removeStep(step)} />
      </div>

      <div className="panel-body">
        {step.assigneeGroups.map((approverGroup) => {
          return (
            <ApproverGroup
              approverGroup={approverGroup}
              key={approverGroup.key}
              step={step}
            />
          );
        })}
        <AddControl aria-label="add-group" onClick={() => addApproverGroup(step)}>Add Approver Group</AddControl>
      </div>
    </div>
  );
};

Step.propTypes = {
  addApproverGroup: PropTypes.func.isRequired,
  changeStepMode: PropTypes.func.isRequired,
  removeStep: PropTypes.func.isRequired,
  step: PropTypes.shape({
    assigneeGroups: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired
    })).isRequired,
    index: PropTypes.number.isRequired
  }).isRequired
};

const mapDispatchToProps = {
  addApproverGroup,
  changeStepMode,
  removeStep
};

export default connect(null, mapDispatchToProps)(Step);
